import { render, staticRenderFns } from "./AboutUs_PT.vue?vue&type=template&id=1a63cc18&scoped=true&"
import script from "./AboutUs_PT.vue?vue&type=script&lang=js&"
export * from "./AboutUs_PT.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_PT.vue?vue&type=style&index=0&id=1a63cc18&prod&lang=css&"
import style1 from "./AboutUs_PT.vue?vue&type=style&index=1&id=1a63cc18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a63cc18",
  null
  
)

export default component.exports